document.addEventListener( 'DOMContentLoaded', () => {
	document.querySelectorAll( '.tabs' ).forEach( ( tabList ) => {
		const tabs = tabList.querySelectorAll( '.tab-button' );
		const panelsContainer = tabList.nextElementSibling;
		const panels = panelsContainer.querySelectorAll( '.tabs-panel' );

		tabs.forEach( ( tab ) => {
			tab.addEventListener( 'click', () => {
				const activeTab = tabList.querySelector(
					'.tab-button.is-active'
				);
				const activePanel = panelsContainer.querySelector(
					'.tabs-panel.is-active'
				);

				// Deactivate current tab and panel
				if ( activeTab ) {
					activeTab.classList.remove( 'is-active' );
					activeTab.setAttribute( 'aria-selected', 'false' );
				}
				if ( activePanel ) {
					activePanel.classList.remove( 'is-active' );
					activePanel.setAttribute( 'hidden', 'true' );
				}

				// Activate clicked tab and corresponding panel
				tab.classList.add( 'is-active' );
				tab.setAttribute( 'aria-selected', 'true' );
				const targetPanel = panelsContainer.querySelector(
					`#panel-${ tab.dataset.id }`
				);
				if ( targetPanel ) {
					targetPanel.classList.add( 'is-active' );
					targetPanel.removeAttribute( 'hidden' );
				}
			} );
		} );
	} );
} );
